/**
 * Kiểm tra thùng có chỉ chứa duy nhất 1 đơn hàng hay không.
 *
 * Barcode của item có format `#<item_number>_<item_index>`, trong đó phần số
 * trước dấu `_` (item_number) chính là số đơn hàng. Vì vậy một thùng gồm
 * #10025145_1..#10025145_5 vẫn chỉ là 1 đơn hàng.
 *
 * Fail-safe: trả về false khi thùng rỗng, hoặc khi có BẤT KỲ item nào không
 * xác định được item_number. Khi đó giữ nguyên hành vi cũ (vẫn in
 * "MADE IN VIET NAM" trên label thùng) thay vì ẩn sai trên thùng nhiều đơn.
 */
export default (items) => {
    const vItems = Array.isArray(items) ? items : []
    if (!vItems.length) return false

    const orderNumbers = new Set()

    for (const item of vItems) {
        const itemNumber = (!!item && !!item.item_number) ? String(item.item_number) : ''

        if (!itemNumber) return false

        orderNumbers.add(itemNumber)
    }

    return orderNumbers.size === 1
}
